<!--
 * @Description:
 * @Author: 景 彡
 * @Date: 2024-10-30 15:26:42
 * @LastEditors: 景 彡
-->
<template>
  <div class="h-full w-full rounded-2 p4 c-bg">
    <FileManager />
  </div>
</template>

<script setup lang="ts">
definePage({
  meta: {
    title: '文件管理',
    layout: 'admin',
    local: true,
    authorize: [],
    layoutRoute: {
      meta: {
        icon: 'FolderOutlined',
        title: '文件管理',
        authorize: [],
        order: 14,
      },
    },
  },
})
</script>

<style scoped></style>
